import React from 'react';
import {observer} from 'mobx-react';
import {endpoints, types} from 'main/tools';
import {EmployeeNameWithAvatar, Layout, Panel, InteractiveContext, Pagination, SearchBox, FancyFilter} from 'components';
import FancyFilterPills from 'components/tables/interactive/components/fancy_filter/FancyFilterPills';
import {NmbrUpdate} from 'stores/nmbr';
import {FormattedMessage} from 'react-intl';
import NmbrUpdateFactory from './NmbrUpdateFactory';
import Subnav from '../../Subnav';
import _ from 'lodash';
import ErroredEmployeesWarning from '../../ErroredEmployeesWarning';

function fancyFilters() {
  const filters = ['location', 'department', 'employment_status', 'employment_type'];

  return filters;
}

const FilterRow = observer(({...rest}) => {
  return (
    <Panel compact className='mb2'>
      <div className='FilterRow flex align-items-middle bg-white'>
        <div className='flex flex-wrap flex-grow row-gap-2'>
          <SearchBox {...rest}/>
          <div className='ml1 flex align-items-start'>
            <FancyFilterPills {...rest}/>
          </div>
        </div>
        <div className='FilterGroup-searchable flex align-items-center flex-wrap ml2'>
          <FancyFilter filters={fancyFilters()} {...rest}/>
        </div>
      </div>
    </Panel>
  );
});

const EmptyState = () => {
  return (
    <Panel>
      <div className='center jumbo rounded h5 py2 px1 Table-emptyState'>
        <FormattedMessage id={'nmbr.updates.directory.No payroll updates to show.'}/>
      </div>
    </Panel>
  );
};

const Updates = observer(({models}) => {
  if (_.isEmpty(models)) return <EmptyState/>;

  return (
    <Panel.Stack loose>
      {models.map(model => <Panel>
        <Panel.Header title={
          <div>
            <div>
              {model.createdAtView}
            </div>
          </div>
        }>
          <div className='jumbo'>
            <FormattedMessage id='nmbr.updates.directory.CREATED_BY_USER' values={{name: _.get(model.createdByUser, 'name', 'Collage')}}/>
          </div>
        </Panel.Header>
        <div className='flex'>
          <div className='col-4 mr2'>
            <div className='h3 mb2'>
              <FormattedMessage id={`nmbr.updates.directory.event_types.${model.eventType}`}/>
              <div className='h5 jumbo'>
                <FormattedMessage id='nmbr.updates.directory.EFFECTIVE_DATE' values={{date: model.effectiveDateView}}/>
              </div>
            </div>
            <EmployeeNameWithAvatar employee={model.employee}/>
          </div>
          <div className='col-8'>
            <NmbrUpdateFactory nmbrUpdate={model}/>
          </div>
        </div>
      </Panel>)}
    </Panel.Stack>
  );
});

const NmbrUpdatesDirectory = observer(({erroredNmbrEmployees}) => {
  return (
    <div>
      <Subnav/>
      <Layout>
        <ErroredEmployeesWarning erroredNmbrEmployees={erroredNmbrEmployees}/>
        <InteractiveContext
          proxy={{
            type: 'async',
            endpoint: endpoints.NMBR.UPDATES.ALL,
            modelType: types.NMBR.UPDATE,
            model: NmbrUpdate,
            pageSize: 10
          }}
          saveStateToUrl
        >
          <FilterRow/>
          <Updates/>
          <Pagination/>
        </InteractiveContext>
      </Layout>
    </div>
  );
});

export default NmbrUpdatesDirectory;
